import {createElement} from 'react'

const withInnerElement = (innerElement) => (Component) => (props) => createElement(
  Component,
  props,
  innerElement,
)

export default withInnerElement
